import { Navigate, Route, Routes } from 'react-router'
import { ReviewsAccessLayout } from 'pages/reviews/layout/ReviewsAccessLayout'
import { ReviewsPageLayout } from 'pages/reviews/layout/ReviewsPageLayout'
import { AllReviews, CreateReview, EditReview, ViewReview } from 'pages/reviews/pages'
import { ReviewsRoutes } from './type'

export const ReviewsRouter = () => {
  return (
    <Routes>
      <Route element={<ReviewsAccessLayout />}>
        <Route element={<ReviewsPageLayout />}>
          <Route index element={<AllReviews />} />
          <Route path={`${ReviewsRoutes.create}`} element={<CreateReview />} />
          <Route path={`${ReviewsRoutes.edit}/:id`} element={<EditReview />} />
          <Route path={`${ReviewsRoutes.clone}/:id`} element={<EditReview isDuplicate={true} />} />
          <Route path={`${ReviewsRoutes.view}/:id`} element={<ViewReview />} />
          <Route path={'*'} element={<Navigate to={'/'} replace />} />
        </Route>
      </Route>
    </Routes>
  )
}
